import { markerSchema } from '@/models/markerSchema';
import { markerIdsSetSelector } from '@/redux/markers/markers.selectors';
import { addMarkerToMarkersData } from '@/redux/markers/markers.slice';
import { store } from '@/redux/store';
import { v4 as uuidv4 } from 'uuid';
import type { Marker, MarkerWithOptionalId } from 'minerva-plugin-api';

export const addSingleMarker = (markerWithoutId: MarkerWithOptionalId): Marker => {
  const { dispatch, getState } = store;
  // an explicit `id: undefined` must not override the generated id
  const marker = { ...markerWithoutId, id: markerWithoutId.id ?? uuidv4() } as Marker;
  markerSchema.parse(marker);

  if (markerIdsSetSelector(getState()).has(marker.id)) {
    throw new Error(
      `Marker with id "${marker.id}" is already shown. Use updateSingleMarker to change it.`,
    );
  }

  dispatch(addMarkerToMarkersData(marker));

  return marker;
};
